<template>
  <div class="aison-app-field-row">
    <div class="d-flex">
      <b-row class="app-row">
        <b-col xs="12" md="4">
          <!-- label&#45;cols&#45;sm="4" -->
          <!-- label&#45;cols&#45;md="0" -->
          <b-form-group
            label="Legend"
            label-cols="2"
            label-size="sm"
            label-align="right"
            label-class="d-md-none"
            :label-for="legend"
          >
            <b-form-input
              :id="legend"
              v-model="legend"
              type="text"
              :disabled="!enabled"
              required
              class="my-1"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col xs="12" md="4">
          <b-form-group
            label="Store As"
            label-cols="2"
            label-size="sm"
            label-align="right"
            label-class="d-md-none"
            :label-for="store_as"
          >
            <b-form-input
              :id="store_as"
              v-model="store_as"
              type="text"
              :disabled="!enabled"
              required
              size="sm"
              class="my-1"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col xs="12" md="4">
          <b-form-group
            label="Type"
            label-cols="2"
            label-size="sm"
            label-align="right"
            label-class="d-md-none"
            :label-for="data_type"
          >
            <b-form-select
              v-model="data_type"
              :options="types"
              :disabled="!enabled"
              required
              size="sm"
              class="my-1"
              :id="data_type"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <!-- <b&#45;col cols="2" v&#45;if="metadata" class="metadata&#45;wrapper"> -->
        <!--   <span -->
        <!--     v&#45;for="(value, key) of metadata.aisonTypes" -->
        <!--     :key="key" -->
        <!--     class="metadata pr&#45;2" -->
        <!--   > -->
        <!--     <em>{{ key }}:</em> {{ value }} -->
        <!--   </span> -->
        <!-- </b&#45;col> -->
      </b-row>
      <b-button
        size="sm ml-2"
        variant="light"
        @click="$emit('remove')"
        tabindex="-1"
      >
        <!-- :disabled="!removable(index)" -->
        <i class="bi bi-x" />
      </b-button>
    </div>
      <hr class="d-sm-block d-md-none"/>
  </div>
</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue';

import * as generators from '@aison/migrator/lib/generators';
import { AisonApplicationFieldCreateData } from '@aison/migrator/lib/adapters';

const FIELD_OPTIONS = generators.AisonApplicationGenerator.FIELD_TYPES.map(
  value => ({ text: value, value })
);

export default defineComponent({
  name: 'AisonApplicationFieldFormRow',
  props: {
    value: {
      type: Object as () => AisonApplicationFieldCreateData,
    },
    metadata: {
      type: Object as () => generators.AisonApplicationFieldResult,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      store_as: this.value?.store_as || '',
      legend: this.value?.legend || '',
      data_type: this.value?.data_type,
    };
  },
  computed: {
    types() {
      return FIELD_OPTIONS;
    },
  },
  methods: {
    changed() {
      this.$emit('input', {
        store_as: this.store_as,
        legend: this.legend,
        data_type: this.data_type,
      });
    },
  },
  watch: {
    store_as() {
      this.changed();
    },
    legend() {
      this.changed();
    },
    data_type() {
      this.changed();
    },
    value(val) {
      this.store_as = val.store_as;
      this.legend = val.legend;
      this.data_type = val.data_type;
    },
  },
});
</script>
<style scoped>
.metadata-wrapper {
  display: flex;
}

.metadata {
  font-size: 1em;
  line-height: 1;
  font-family: monospace;
  white-space: nowrap;
}

.app-row {
  flex-grow: 1;
}
</style>
<style>
.aison-app-field-row {
  display: flex;
  flex-direction: column;
}

.aison-app-field-row .form-group {
  margin-bottom: 0;
}
</style>
